import Api from './Api'
import { AdvancedSearchInterface } from '../../interfaces/search'
import { SearchTypeEnum, _PharmacyTypeEnum } from '../../enum'
import { ReactText } from 'react'

class Search extends Api {
  advancedSearch = async (
    data: AdvancedSearchInterface,
    count = 10,
    from = 0,
  ): Promise<any> => {
    const result = await this.postJsonData(
      `/Search/AdvancedSearch?count=${count}&from=${from}`,
      data,
    )
    return result.data
  }

  searchDrug = async (
    drugName: string,
    containsDisables?: boolean,
    searchType?: string,
    count?: ReactText,
  ): Promise<any> => {
    const result = await this.getData(
      `/Search/SearchDrug?name=${drugName}&searchType=${
        searchType ?? ''
      }&count=${count ?? 99}
      &containsDisables=${containsDisables ?? false}`,
    )
    return result.data
  }

  searchCategory = async (name: string, count = 10): Promise<any> => {
    const result = await this.getData(
      `/Search/SearchCategory?name=${name}&count=${count}`,
    )
    return result.data
  }

  searchPharmacy = async (
    name: string,
    searchType?: _PharmacyTypeEnum,
    count = 100,
  ): Promise<any> => {
    const params = new URLSearchParams();
    params.append('name', name);
    if (searchType) {
      params.append('searchType', searchType);
    }
    params.append('count', count.toString());

    const result = await this.getData(
      `/Search/SearchPharmacy?${params.toString()}`,
    )
    return result.data
  }

  searchUser = async (userName: string, count?: number): Promise<any> => {
    const result = await this.getData(
      `/Search/SearchUser?name=${userName}&count=${count ?? 100}&searchType=${
        SearchTypeEnum.CONTAINS
      }`,
    )
    return result.data
  }
}

export default Search
